module.exports = __webpack_public_path__ + "static/media/MOInvesternewnew.bef22e78.png";